<mat-nav-list dense>
  <a mat-list-item [routerLink]="['/']"
     [routerLinkActive]="['active']"
     [routerLinkActiveOptions]="{ exact: true }">
    <mat-icon mat-list-icon>home</mat-icon>
    <div mat-line>Главная</div>
  </a>
  <a mat-list-item *ngIf="showTests"
     [routerLink]="['/tests']"
     [routerLinkActive]="['active']">
    <mat-icon mat-list-icon>fact_check</mat-icon>
    <div mat-line>Тесты</div>
  </a>
  <a mat-list-item *ngIf="showUsers"
     [routerLink]="['/users']"
     [routerLinkActive]="['active']">
    <mat-icon mat-list-icon>account_box</mat-icon>
    <div mat-line>Пользователи</div>
  </a>
</mat-nav-list>
